// pdfWorker.js
import * as pdfjsLib from "pdfjs-dist";

// Set the worker path to the pdf.worker.js file from the pdfjs-dist package
pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

export default pdfjsLib;
